export default __webpack_public_path__ + "img/service_DS1.fa0b99930b0f9432f052c3485156a72c.jpg";